import { FC } from "react";
import { IPageAction } from "../../../base/models";
import { MUIIcon } from "../../../widgets";
import clsx from "clsx";
import { useUmsUrl } from "../services/useTouUrl";

interface IActionUMSLinkProps {
    action: IPageAction
    className?: string
}

export const ActionUMSLink: FC<IActionUMSLinkProps> = ({
    action, className
}) => {
    const { umsUrl } = useUmsUrl()

    if (!umsUrl)
        return <button
            type="button"
            className={className}>
            {action.icon && <MUIIcon iconName={action.icon} className="me-1" />}
            {action.name}
        </button>

    return (
        <a
            className={clsx(className, "btn btn-secondary btn-sm")}
            href={umsUrl}>
            {action.icon && <MUIIcon iconName={action.icon} className="me-1" />}
            <span>{action.name}</span>
        </a>
    )
}
